import React from 'react';
export const SignIn = React.lazy(() => import('./SignIn'));